module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content diamond-content"
  }, [_c('div', {
    staticClass: "row diamond-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Lịch sử điểm Diamond")]), _c('div', {
    staticClass: "col-md-3 box-content-left"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/images/point/Mask Group 24.svg")
    }
  }), _c('div', {
    staticClass: "total-diamond"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.totalDiamond)))])])])])]), _c('div', {
    staticClass: "col-md-9 box-content-right"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('div', [_vm._v(_vm._s(_vm.lstUserSameRank))])])])])]), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [(!_vm.mobile) ? _c('div', {
    staticClass: "box-list-diamond"
  }, [_vm._m(0), _c('div', {
    staticClass: "box-diamond-scroll"
  }, [_vm._l((_vm.diamondList), function(o, index) {
    return _c('div', {
      staticClass: "box-diamond-items"
    }, [_c('span', [_vm._v(_vm._s(index + 1))]), (!o.question_id) ? _c('span', [_vm._v(_vm._s(o.name)), (o.grade) ? _c('a', {
      staticClass: "link-object",
      on: {
        "click": _vm.onObject
      }
    }, [_vm._v(_vm._s(o.grade && o.grade.name))]) : (o.competition) ? _c('a', {
      staticClass: "link-object",
      on: {
        "click": _vm.onObject
      }
    }, [_vm._v(_vm._s(o.competition && o.competition.name))]) : (o.subject) ? _c('a', {
      staticClass: "link-object",
      on: {
        "click": _vm.onObject
      }
    }, [_vm._v(_vm._s(o.subject && o.subject.name))]) : (o.qa_id) ? _c('a', {
      staticClass: "link-object",
      on: {
        "click": _vm.onObject
      }
    }, [_vm._v("mã câu hỏi")]) : _c('a', {
      staticClass: "link-object"
    }, [_vm._v("ABCXYZ")])]) : (o.question_id) ? _c('span', [_vm._v(_vm._s(o.name)), _c('a', {
      staticClass: "link-object",
      on: {
        "click": _vm.onObject
      }
    }, [_vm._v("câu hỏi ")]), _vm._v("50/50")]) : _vm._e(), (!o.question_id) ? _c('span', [_vm._v(", bạn được tặng ")]) : _vm._e(), (o.question_id) ? _c('span', [_vm._v(", bạn đã dùng ")]) : _vm._e(), (o.amount > 0) ? _c('span', {
      staticClass: "plus"
    }, [_vm._v("+ " + _vm._s(_vm.formatNumber(o.amount)) + " điểm")]) : _c('span', {
      staticClass: "minus"
    }, [_vm._v("- " + _vm._s(_vm.formatNumber(-o.amount)) + " điểm")]), _vm._v(" diamond"), _c('span', [_vm._v(_vm._s(_vm._f("moment")(o.created_at)))])])
  }), _c('observer', {
    on: {
      "intersect": _vm.onIntersected
    }
  })], 2)]) : _c('div', {
    staticClass: "box-list-diamond-kanban"
  }, [(_vm.diamondList && _vm.diamondList.length === 0) ? _c('div', {
    staticClass: "box-kanban-diamond-default"
  }, [_c('div', [_vm._v("CHƯA CÓ HOẠT ĐỘNG DIAMOND")])]) : _vm._e(), (_vm.diamondList && _vm.diamondList.length > 0) ? _c('div', {
    staticClass: "box-diamond-scroll-kanban"
  }, _vm._l((_vm.diamondList), function(o) {
    return _c('div', {
      staticClass: "box-kanban-diamond"
    }, [(!o.question_id) ? _c('div', [_vm._v(_vm._s(o.name)), (o.grade) ? _c('a', {
      staticClass: "link-object",
      on: {
        "click": _vm.onObject
      }
    }, [_vm._v(_vm._s(o.grade && o.grade.name))]) : (o.competition) ? _c('a', {
      staticClass: "link-object",
      on: {
        "click": _vm.onObject
      }
    }, [_vm._v(_vm._s(o.competition && o.competition.name))]) : (o.subject) ? _c('a', {
      staticClass: "link-object",
      on: {
        "click": _vm.onObject
      }
    }, [_vm._v(_vm._s(o.subject && o.subject.name))]) : (o.qa_id) ? _c('a', {
      staticClass: "link-object",
      on: {
        "click": _vm.onObject
      }
    }, [_vm._v("mã câu hỏi")]) : _c('a', {
      staticClass: "link-object"
    }, [_vm._v("ABCXYZ")]), (!o.question_id) ? _c('span', [_vm._v(", bạn được tặng ")]) : _vm._e(), (o.amount > 0) ? _c('span', {
      staticClass: "plus"
    }, [_vm._v("+ " + _vm._s(_vm.formatNumber(o.amount)) + " điểm")]) : _c('span', {
      staticClass: "minus"
    }, [_vm._v("- " + _vm._s(_vm.formatNumber(-o.amount)) + " điểm")]), _vm._v(" diamond")]) : (o.question_id) ? _c('div', [_vm._v(_vm._s(o.name)), _c('a', {
      staticClass: "link-object",
      on: {
        "click": _vm.onObject
      }
    }, [_vm._v("câu hỏi ")]), _vm._v("50/50"), (o.question_id) ? _c('span', [_vm._v(", bạn đã dùng ")]) : _vm._e(), (o.amount > 0) ? _c('span', {
      staticClass: "plus"
    }, [_vm._v("+ " + _vm._s(_vm.formatNumber(o.amount)) + " điểm")]) : _c('span', {
      staticClass: "minus"
    }, [_vm._v("- " + _vm._s(_vm.formatNumber(-o.amount)) + " điểm")]), _vm._v(" diamond")]) : _vm._e(), _c('div', [_vm._v(_vm._s(_vm._f("moment")(o.created_at)))])])
  }), 0) : _vm._e(), _c('observer', {
    on: {
      "intersect": _vm.onIntersected
    }
  })], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-diamond-header"
  }, [_c('span', [_vm._v("STT")]), _c('span', [_vm._v("Hoạt động")]), _c('span', [_vm._v("Ngày giờ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fae54a52","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Point/Diamond.vue
// module id = 1666
// module chunks = 0